import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronRight, faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import { Link } from "react-router-dom";
import './Breadcrumb.css';

const Breadcrumb = ({ breadcrumbItems, backLink, backLinkState }) => {
  return (
    <nav className="breadcrumb-container">
      {backLink && (
        <Link to={backLink} state={backLinkState} className="back-icon">
          <FontAwesomeIcon icon={faArrowLeft} className="breadcrumb-icon" />
        </Link>
      )}
      {
        // Array.isArray(breadcrumbItems) &&
        breadcrumbItems.map((item, index) => (
          <React.Fragment key={index}>
            {item.link ? (
              <Link to={item.link} state={item.state} className="breadcrumb-link">
                {item.label}
              </Link>
            ) : (
              <span className="breadcrumb-current">{item.label}</span>
            )}
            {index < breadcrumbItems.length - 1 && (
              <FontAwesomeIcon
                icon={faChevronRight}
                className="breadcrumb-separator"
              />
            )}
          </React.Fragment>
        ))
      }
    </nav>
  );
};

export default Breadcrumb;
